import styled from "styled-components";

export const SimilarResultsContainer = styled.div`
  width: 100%;
  display: flex;
  background: #f5f5f5;

  @media only screen and (min-width: 768px) {
    background-size: cover;
    background-repeat: no-repeat;
    justify-content: center;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  background: white;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 900px) {
    padding: 3rem;
  }
`;

export const ContentHeader = styled.div`
  margin-bottom: 2rem;
`;

export const ContentTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin: 0;
  text-align: center;

  strong {
    font-weight: bold;
  }
`;

export const ResultsList = styled.div`
  display: flex;
  width: 380px;
  padding: 40px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  background: #fff;
`;

export const ResultItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ProfileImage = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 12px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 1.5rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;

export const CitizenDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column; /* Stack vertically on mobile */
    gap: 12px;
  }
`;

export const Col = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex: none;
    margin-bottom: 12px;
  }
`;

export const DetailValue = styled.span`
  color: #000;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  strong {
    font-weight: 700;
  }
`;

export const BottomAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`;

export const NotYouText = styled.div`
  font-size: 0.9rem;
  color: #666;
`;

export const NewRegistrationButton = styled.button`
  border-radius: 6px;
  border: 1px solid #0d47a1;
  background: #fff;
  padding: 0.75rem 2rem;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: #0d47a1;
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;

  &:hover {
    background: #e6f0ff;
  }

  &:focus-visible {
    outline: 2px solid #0d47a1;
    outline-offset: 2px;
  }
`;

export const VerificationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.25rem;
`;

export const VerificationQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  span {
    color: #000;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const StyledHR = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #dbdbdb;
  margin: 1.5rem 0;
`;

export const ContinueButton = styled.button`
  background: none;
  border: none;
  color: #0d47a1;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid #0d47a1;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
